import React from "react";

import starImg from "../assets/core/img/star.png";
import lockedImg from "../assets/core/img/locked.png";
import unlockedImg from "../assets/core/img/unlocked.png";

function LevelCard({ locked, level, onClick }) {
  let bgColor = locked ? "bg-retro-grey" : "bg-retro-yellow";
  let cursor = locked ? "cursor-not-allowed" : "cursor-pointer";
  let lockImg = locked ? lockedImg : unlockedImg;
  let stars = level < 3 ? 1 : level < 5 ? 2 : 3;
  let starStore = [];

  let lefts = ["left-0", "left-[30px]", "left-[60px]"];

  for (let i = 0; i < stars; i++) {
    let left = lefts[i];

    starStore.push(
      <img
        key={i}
        className={`w-[30px] absolute bottom-0 ${left} ${cursor}`}
        src={starImg}
        onClick={locked ? null : onClick}
        alt=""
      />
    );
  }

  return (
    <div className="relative h-40 w-full">
      <div
        className={`relative h-[calc(100%_-_15px)] ${bgColor} border border-black ${cursor}`}
        onClick={locked ? null : onClick}
      >
        <p className="text-[120%] uppercase font-retro-sabo text-center mt-[5%]">
          Level
        </p>
        <p className="text-8xl text-center font-retro-rounded font-medium leading-none">
          {level}
        </p>
        <img
          className="w-[30px] absolute bottom-1 right-1"
          src={lockImg}
          alt=""
        />
      </div>

      {starStore}
    </div>
  );
}

export default LevelCard;
